module.exports = __webpack_public_path__ + "img/45.551959dc.jpg";